export const T = {
  en_GB: {
    newAccount: "New account",
    fromAccount: "From account",
    toAccount: "To account",
    amount: "Amount",
    amountWithCurrency: (currency: string) => `Amount (${currency})`,
    availableCash: "Available",
    availableCashFailed: "Could not load the available cash.",
    useAll: "Use all",
    addTransfer: "Add transfer",
    editTransfer: "Edit transfer",
    transferDialogDescription: "Transfer cash between two accounts.",
    save: "Save",
    cancel: "Cancel",
    selectAccount: "Select account",
    fromRequired: "Select the account to transfer from",
    toRequired: "Select the account to transfer to",
    sameAccount: "Choose two different accounts",
    amountRequired: "Enter an amount greater than zero",
    failedToSave: "Failed to save transfer",
  },
  nb_NO: {
    newAccount: "Ny konto",
    fromAccount: "Fra konto",
    toAccount: "Til konto",
    amount: "Beløp",
    amountWithCurrency: (currency: string) => `Beløp (${currency})`,
    availableCash: "Tilgjengelig",
    availableCashFailed: "Kunne ikke laste tilgjengelige kontanter.",
    useAll: "Bruk alt",
    addTransfer: "Legg til overføring",
    editTransfer: "Rediger overføring",
    transferDialogDescription: "Overfør kontanter mellom to kontoer.",
    save: "Lagre",
    cancel: "Avbryt",
    selectAccount: "Velg konto",
    fromRequired: "Velg kontoen det skal overføres fra",
    toRequired: "Velg kontoen det skal overføres til",
    sameAccount: "Velg to forskjellige kontoer",
    amountRequired: "Angi et beløp større enn null",
    failedToSave: "Kunne ikke lagre overføringen",
  },
} as const;
